"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * GroupOfSitesConverter.
 *
 * @author JMe
 */


var GroupOfSitesConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(GroupOfSitesConverter, _DataObjectConverter_);

  function GroupOfSitesConverter() {
    _classCallCheck(this, GroupOfSitesConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupOfSitesConverter).apply(this, arguments));
  }

  return GroupOfSitesConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.GroupOfSitesConverter = GroupOfSitesConverter;